import React from "react";
import { useNavigate } from "react-router-dom";
import logo from "../../assests/logo.png";
import dine from "../../assests/Group.svg";
import takeaway from "../../assests/Group-1.svg";
import { useOrder } from "./OrderContext";

const Choice: React.FC = () => {
  const navigate = useNavigate();
  const { orderData, setOrderData } = useOrder();

  const handleChoice = (choice: string) => {
    setOrderData({
      items: orderData?.items || [],
      totalAmount: orderData?.totalAmount || "0",
      ...orderData,
      choice,
    });
    navigate("/pos");
  };

  return (
    <div className="w-full h-screen flex flex-col justify-center items-center  px-4 sm:px-6 lg:px-8 py-8">
      <h1 className="mb-4  text-3xl sm:text-4xl md:text-5xl lg:text-6xl px-12  font-bold text-black capitalize text-center ">
        What would you like to eat?
      </h1>

      <div className="flex flex-col  sm:flex-row items-center justify-center gap-5 sm:gap-6 md:gap-8 lg:gap-10 mt-6 sm:mt-8 md:mt-10 w-full mx-auto max-w-4xl">
        {/* Dining In */} 
        <div
          className="flex flex-col items-center justify-center w-full sm:w-64 md:w-72 lg:w-80 py-4 sm:py-5 px-4 sm:px-5 text-base font-medium text-center border-2 border-main bg-white rounded-2xl gap-4 sm:gap-5 hover:scale-105 transition-transform duration-300 ease-in-out cursor-pointer"
          onClick={() => handleChoice("Dining In")}
        >
          <img src={dine} alt="dining option" className="w-16 h-16" />
          <span className="text-black text-2xl font-semibold">Dining In</span>
        </div>

        {/* Takeaway */}
        <div
          className="flex flex-col items-center justify-center w-full sm:w-64 md:w-72 lg:w-80 py-4 sm:py-5 px-4 sm:px-5 text-base font-medium text-center border-2 border-main bg-white rounded-2xl gap-4 sm:gap-5 hover:scale-105 transition-transform duration-300 ease-in-out cursor-pointer"
          onClick={() => handleChoice("Takeaway")}
        >
          <img src={takeaway} alt="takeaway option" className="w-16 h-16" />
          <span className="text-black text-2xl font-semibold">Takeaway</span>
        </div>
      </div>
    </div>
  );
};

export default Choice;
